import { useCallback } from 'react'

import { Button, Flex } from 'antd'
import { Icon, Modal } from 'govwell-ui'
import { useLocalStorage } from 'usehooks-ts'

import ContactGovWellAboutAIAssistantButton from 'src/components/AIAssistant/ContactGovWellAboutAIAssistantButton'
import Text from 'src/components/Typography/Text'
import { LocalStorageKey } from 'src/types'

type Props = {
  isOpen: boolean
  onTryOutAIAssistant: () => void | Promise<void>
  onClose: () => void | Promise<void>
}

const ContactGovWellAboutAIAssistantModal = ({ isOpen, onTryOutAIAssistant, onClose }: Props) => {
  const [hasClosedAIAssistantModal, setHasClosedAIAssistantModal] = useLocalStorage(
    LocalStorageKey.HasClosedAIAssistantModal,
    false
  )
  const handleClose = useCallback(async () => {
    setHasClosedAIAssistantModal(true)
    await onClose()
  }, [onClose, setHasClosedAIAssistantModal])

  const handleTryOutAIAssistant = useCallback(async () => {
    setHasClosedAIAssistantModal(true)
    await onClose()
    await onTryOutAIAssistant()
  }, [onTryOutAIAssistant, onClose, setHasClosedAIAssistantModal])

  return (
    isOpen &&
    !hasClosedAIAssistantModal && (
      <Modal onClose={handleClose}>
        <Modal.Header>The Community Assistant is not Enabled</Modal.Header>
        <Modal.Content>
          <Flex vertical gap="12px">
            <Text>
              GovWell&apos;s Community Assistant listens to the questions your community is asking
              and helps you build a smart, growing FAQ database — answer a question once, and
              GovWell remembers it forever.
            </Text>
            <Text>
              This saves your team time by automating responses to repetitive public inquiries.
            </Text>
            <Text>Want a personalized walkthrough? Contact us to see how it can work for you.</Text>
          </Flex>
        </Modal.Content>
        <Modal.Footer>
          <ContactGovWellAboutAIAssistantButton
            type="default"
            text="Contact us"
            onClick={handleClose}
          />
          <Button icon={<Icon.FaArrowRight />} type="primary" onClick={handleTryOutAIAssistant}>
            Try out the Community Assistant
          </Button>
        </Modal.Footer>
      </Modal>
    )
  )
}

export default React.memo(ContactGovWellAboutAIAssistantModal)
